import { getIcon, getAlerceLogo } from './ui.js';
import { CONFIG } from '../config.js';
import { AuthService } from '../services/auth.js';
import { DataService } from '../services/data.js';

export function renderLayout(contentHtml, activeRoute = 'dashboard') {
  const isCollapsed = typeof window !== 'undefined' && localStorage.getItem('alerce_sidebar_collapsed') === 'true';

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'dashboard', path: '#/dashboard' },
    { id: 'projects', label: 'Proyectos & Horas', icon: 'briefcase', path: '#/projects' },
    { id: 'pipeline', label: 'Comercial & Clientes', icon: 'kanban', path: '#/pipeline' },
    { id: 'email-marketing', label: 'Email Marketing', icon: 'mail', path: '#/email-marketing' },
    { id: 'resources', label: 'Recursos', icon: 'folder', path: '#/resources' },
    { id: 'finance', label: 'Finanzas & Cobros', icon: 'dollar', path: '#/finance' },
    { id: 'rates', label: 'Tarifas (ABM)', icon: 'tag', path: '#/rates' },
    { id: 'knowledge', label: 'Knowledge OS', icon: 'book', path: '#/knowledge' },
    { id: 'settings', label: 'Configuración', icon: 'settings', path: '#/settings' }
  ];

  return `
    <div class="min-h-[100dvh] flex bg-background">
      <!-- Desktop Sidebar -->
      <aside id="desktop-sidebar" class="${isCollapsed ? 'w-16' : 'w-64'} border-r border-border bg-surface flex flex-col justify-between shrink-0 hidden md:flex transition-all duration-300 ease-in-out select-none">
        <div>
          <!-- Logo & Collapse Toggle -->
          <div class="h-16 flex items-center ${isCollapsed ? 'justify-center px-2' : 'justify-between px-4'} border-b border-border">
            <div class="flex items-center gap-2.5 overflow-hidden ${isCollapsed ? 'hidden' : 'flex'} sidebar-brand-container">
              ${getAlerceLogo('w-7 h-7 rounded-md shadow-sm')}
              <span class="font-bold text-sm tracking-tight text-primary">EQUIPO ALERCE OS</span>
              <span class="text-[10px] font-mono px-1.5 py-0.5 rounded bg-surface-subtle border border-border text-text-secondary font-medium">
                v${CONFIG.VERSION}
              </span>
            </div>

            <button 
              id="btn-toggle-sidebar" 
              title="${isCollapsed ? 'Expandir menú lateral' : 'Colapsar menú lateral'}" 
              class="p-1.5 text-text-secondary hover:text-text-primary hover:bg-surface-subtle rounded-md transition-colors"
            >
              ${getIcon(isCollapsed ? 'chevronRight' : 'chevronLeft', 'w-4 h-4')}
            </button>
          </div>

          <!-- Navigation Links -->
          <nav class="p-2 space-y-1">
            ${navItems.map(item => {
              const isActive = activeRoute === item.id;
              return `
                <a 
                  href="${item.path}" 
                  title="${item.label}" 
                  class="sidebar-nav-item flex items-center ${isCollapsed ? 'justify-center px-2' : 'justify-start px-3'} py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive 
                      ? 'bg-primary text-white font-semibold shadow-sm' 
                      : 'text-text-secondary hover:text-text-primary hover:bg-surface-subtle'
                  }"
                >
                  ${getIcon(item.icon, `w-4 h-4 shrink-0 ${isActive ? 'text-white' : 'text-text-secondary'}`)}
                  <span class="sidebar-nav-label ml-3 ${isCollapsed ? 'hidden' : 'inline'} truncate">${item.label}</span>
                </a>
              `;
            }).join('')}
          </nav>
        </div>

        <!-- User / Status Footer -->
        <div class="p-3 border-t border-border bg-surface-subtle/50">
          <div class="flex items-center ${isCollapsed ? 'justify-center' : 'justify-between'} mb-2.5">
            <div class="flex items-center gap-2" title="Supabase Online">
              <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse shrink-0"></span>
              <span class="text-xs font-mono text-text-secondary ${isCollapsed ? 'hidden' : 'inline'} sidebar-db-text" id="sidebar-db-status">Supabase Online</span>
            </div>
          </div>
          <div class="flex items-center ${isCollapsed ? 'justify-center flex-col gap-2' : 'justify-between'} pt-2 border-t border-border/60">
            <div class="flex items-center gap-2.5 overflow-hidden" title="${CONFIG.OWNER} (${CONFIG.OWNER_EMAIL})">
              <div class="w-7 h-7 rounded-full bg-primary text-white font-bold text-xs flex items-center justify-center shrink-0">
                M
              </div>
              <div class="truncate ${isCollapsed ? 'hidden' : 'block'} sidebar-user-info">
                <p class="text-xs font-semibold text-text-primary truncate">${CONFIG.OWNER}</p>
                <p class="text-[11px] text-text-secondary truncate font-mono">${CONFIG.OWNER_EMAIL}</p>
              </div>
            </div>
            <button id="btn-logout" title="Cerrar sesión" class="p-1.5 text-text-secondary hover:text-text-primary hover:bg-surface rounded-md transition-colors">
              ${getIcon('logOut', 'w-4 h-4')}
            </button>
          </div>
        </div>
      </aside>

      <!-- Main Content Area -->
      <div class="flex-1 flex flex-col min-w-0">
        <!-- Top Navbar -->
        <header class="h-16 border-b border-border bg-surface flex items-center justify-between px-4 sm:px-6 sticky top-0 z-30">
          <div class="flex items-center gap-3">
            <!-- Mobile nav trigger (Hamburger) -->
            <button id="btn-toggle-mobile-menu" class="md:hidden p-2 -ml-1 text-text-secondary hover:text-text-primary hover:bg-surface-subtle rounded-md transition-colors" aria-label="Abrir menú de navegación">
              ${getIcon('menu', 'w-5 h-5')}
            </button>

            <!-- Mobile Brand Logo -->
            <div class="md:hidden flex items-center gap-2">
              ${getAlerceLogo('w-6 h-6 rounded-md shadow-sm')}
              <span class="font-bold text-sm text-primary">EQUIPO ALERCE OS</span>
              <span class="text-[10px] font-mono px-1.5 py-0.5 rounded bg-surface-subtle border border-border">v${CONFIG.VERSION}</span>
            </div>
          </div>

          <div class="flex items-center gap-2 sm:gap-3">
            <!-- Fast Time Logging Action -->
            <button id="btn-quick-log" class="inline-flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3.5 py-1.5 sm:py-2 text-xs font-semibold rounded-md bg-primary text-white hover:bg-primary-hover active:bg-primary-active transition-all shadow-sm">
              ${getIcon('plus', 'w-3.5 h-3.5')}
              <span class="hidden xs:inline">Cargar Horas</span>
              <span class="xs:hidden">Horas</span>
            </button>

            <!-- Knowledge OS Direct Link -->
            <a href="#/knowledge" class="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-md border border-border hover:bg-surface-subtle transition-colors text-text-primary">
              ${getIcon('book', 'w-3.5 h-3.5 text-text-secondary')}
              <span>Wiki OKF</span>
            </a>
          </div>
        </header>

        <!-- Main Body -->
        <main class="flex-1 p-4 sm:p-6 md:p-8 max-w-7xl w-full mx-auto">
          ${contentHtml}
        </main>
      </div>
    </div>

    <!-- Fixed Scroll to Top Button (Global) -->
    <button 
      id="btn-scroll-to-top" 
      type="button" 
      aria-label="Volver arriba" 
      title="Volver al inicio de la página" 
      class="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary text-white shadow-lg shadow-primary/25 hover:bg-primary-hover hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center opacity-0 pointer-events-none translate-y-3 cursor-pointer group no-print"
    >
      ${getIcon('arrowUp', 'w-5 h-5 group-hover:-translate-y-0.5 transition-transform')}
    </button>

    <!-- Mobile Drawer Overlay / Backdrop -->
    <div id="mobile-drawer-backdrop" class="fixed inset-0 bg-black/50 z-40 hidden md:hidden transition-opacity no-print"></div>

    <!-- Mobile Slide-over Drawer / Accordion Sidebar -->
    <aside id="mobile-drawer" class="fixed inset-y-0 left-0 w-72 max-w-[85vw] bg-white z-50 transform -translate-x-full transition-transform duration-300 ease-in-out md:hidden flex flex-col justify-between border-r border-border shadow-2xl no-print">
      <div>
        <!-- Drawer Header -->
        <div class="h-16 flex items-center justify-between px-5 border-b border-border">
          <div class="flex items-center gap-2.5">
            ${getAlerceLogo('w-7 h-7 rounded-md shadow-sm')}
            <div>
              <span class="font-bold text-sm tracking-tight text-primary block leading-none">EQUIPO ALERCE OS</span>
              <span class="text-[10px] font-mono text-text-secondary">v${CONFIG.VERSION}</span>
            </div>
          </div>
          <button id="btn-close-mobile-menu" class="p-1.5 text-text-secondary hover:text-text-primary rounded-md" aria-label="Cerrar menú">
            ${getIcon('x', 'w-5 h-5')}
          </button>
        </div>

        <!-- Navigation Links in Drawer -->
        <nav class="p-3 space-y-1">
          ${navItems.map(item => {
            const isActive = activeRoute === item.id;
            return `
              <a href="${item.path}" class="mobile-nav-link flex items-center gap-3 px-3.5 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive 
                  ? 'bg-primary text-white font-semibold shadow-sm' 
                  : 'text-text-secondary hover:text-text-primary hover:bg-surface-subtle'
              }">
                ${getIcon(item.icon, `w-4 h-4 ${isActive ? 'text-white' : 'text-text-secondary'}`)}
                <span>${item.label}</span>
              </a>
            `;
          }).join('')}
        </nav>
      </div>

      <!-- Drawer Footer -->
      <div class="p-4 border-t border-border bg-surface-subtle/60">
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
            <span class="text-xs font-mono text-text-secondary" id="mobile-db-status">Supabase Online</span>
          </div>
        </div>
        <div class="flex items-center justify-between pt-2 border-t border-border/60">
          <div class="flex items-center gap-2.5 overflow-hidden">
            <div class="w-7 h-7 rounded-full bg-primary text-white font-bold text-xs flex items-center justify-center">
              M
            </div>
            <div class="truncate">
              <p class="text-xs font-semibold text-text-primary truncate">${CONFIG.OWNER}</p>
              <p class="text-[11px] text-text-secondary truncate font-mono">${CONFIG.OWNER_EMAIL}</p>
            </div>
          </div>
          <button id="btn-mobile-logout" title="Cerrar sesión" class="p-1.5 text-text-secondary hover:text-text-primary hover:bg-surface rounded-md transition-colors">
            ${getIcon('logOut', 'w-4 h-4')}
          </button>
        </div>
      </div>
    </aside>
  `;
}

// Attach layout event listeners (e.g. logout, quick time entry, mobile menu)
export function initLayoutEvents() {
  const logoutBtn = document.getElementById('btn-logout');
  const mobileLogoutBtn = document.getElementById('btn-mobile-logout');

  [logoutBtn, mobileLogoutBtn].forEach(btn => {
    if (btn) {
      btn.onclick = async () => {
        await AuthService.signOut();
        window.location.hash = '#/login';
      };
    }
  });

  const quickLogBtn = document.getElementById('btn-quick-log');
  if (quickLogBtn) {
    quickLogBtn.onclick = () => {
      const currentHash = window.location.hash || '';
      if (currentHash.startsWith('#/projects')) {
        window.dispatchEvent(new CustomEvent('open-quick-time-modal'));
      } else {
        window.location.hash = '#/projects?action=log';
      }
    };
  }

  // Mobile drawer handlers
  const drawer = document.getElementById('mobile-drawer');
  const backdrop = document.getElementById('mobile-drawer-backdrop');
  const btnToggle = document.getElementById('btn-toggle-mobile-menu');
  const btnClose = document.getElementById('btn-close-mobile-menu');

  const openDrawer = () => {
    if (!drawer || !backdrop) return;
    backdrop.classList.remove('hidden');
    requestAnimationFrame(() => {
      drawer.classList.remove('-translate-x-full');
      drawer.classList.add('translate-x-0');
    });
    document.body.classList.add('overflow-hidden');
  };

  const closeDrawer = () => {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('translate-x-0');
    drawer.classList.add('-translate-x-full');
    setTimeout(() => {
      backdrop.classList.add('hidden');
    }, 300);
    document.body.classList.remove('overflow-hidden');
  };

  if (btnToggle) btnToggle.onclick = openDrawer;
  if (btnClose) btnClose.onclick = closeDrawer;
  if (backdrop) backdrop.onclick = closeDrawer;

  document.querySelectorAll('.mobile-nav-link').forEach(link => {
    link.addEventListener('click', closeDrawer);
  });

  // Check DB ping
  DataService.pingDatabase().then(res => {
    const statusEl = document.getElementById('sidebar-db-status');
    const mobileStatusEl = document.getElementById('mobile-db-status');
    if (res.ok) {
      if (statusEl) statusEl.textContent = `Supabase • ${res.ping}ms`;
      if (mobileStatusEl) mobileStatusEl.textContent = `Supabase • ${res.ping}ms`;
    }
  });

  // Desktop sidebar collapse/expand toggle
  const btnToggleSidebar = document.getElementById('btn-toggle-sidebar');
  if (btnToggleSidebar) {
    btnToggleSidebar.onclick = () => {
      const isCurrentlyCollapsed = localStorage.getItem('alerce_sidebar_collapsed') === 'true';
      const newState = !isCurrentlyCollapsed;
      localStorage.setItem('alerce_sidebar_collapsed', newState ? 'true' : 'false');

      const sidebar = document.getElementById('desktop-sidebar');
      if (sidebar) {
        if (newState) {
          sidebar.classList.remove('w-64');
          sidebar.classList.add('w-16');
          sidebar.querySelectorAll('.sidebar-nav-label').forEach(el => el.classList.add('hidden'));
          sidebar.querySelectorAll('.sidebar-brand-container').forEach(el => el.classList.add('hidden'));
          sidebar.querySelectorAll('.sidebar-user-info').forEach(el => el.classList.add('hidden'));
          sidebar.querySelectorAll('.sidebar-db-text').forEach(el => el.classList.add('hidden'));
          sidebar.querySelectorAll('.sidebar-nav-item').forEach(el => {
            el.classList.remove('justify-start', 'px-3');
            el.classList.add('justify-center', 'px-2');
          });
          btnToggleSidebar.innerHTML = getIcon('chevronRight', 'w-4 h-4');
          btnToggleSidebar.title = 'Expandir menú lateral';
        } else {
          sidebar.classList.remove('w-16');
          sidebar.classList.add('w-64');
          sidebar.querySelectorAll('.sidebar-nav-label').forEach(el => el.classList.remove('hidden'));
          sidebar.querySelectorAll('.sidebar-brand-container').forEach(el => el.classList.remove('hidden'));
          sidebar.querySelectorAll('.sidebar-user-info').forEach(el => el.classList.remove('hidden'));
          sidebar.querySelectorAll('.sidebar-db-text').forEach(el => el.classList.remove('hidden'));
          sidebar.querySelectorAll('.sidebar-nav-item').forEach(el => {
            el.classList.remove('justify-center', 'px-2');
            el.classList.add('justify-start', 'px-3');
          });
          btnToggleSidebar.innerHTML = getIcon('chevronLeft', 'w-4 h-4');
          btnToggleSidebar.title = 'Colapsar menú lateral';
        }
      }
    };
  }

  // Fixed Scroll to Top Button Handler (Global)
  const btnScrollTop = document.getElementById('btn-scroll-to-top');
  if (btnScrollTop) {
    const updateScrollVisibility = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollY > 200) {
        btnScrollTop.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-3');
        btnScrollTop.classList.add('opacity-100', 'pointer-events-auto', 'translate-y-0');
      } else {
        btnScrollTop.classList.remove('opacity-100', 'pointer-events-auto', 'translate-y-0');
        btnScrollTop.classList.add('opacity-0', 'pointer-events-none', 'translate-y-3');
      }
    };

    if (window.__alerceScrollTopListener) {
      window.removeEventListener('scroll', window.__alerceScrollTopListener);
    }
    window.__alerceScrollTopListener = updateScrollVisibility;
    window.addEventListener('scroll', updateScrollVisibility, { passive: true });
    updateScrollVisibility();

    btnScrollTop.onclick = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    };
  }
}
